module.exports = __webpack_public_path__ + "img/s4.a8cab282.png";